import { FC } from "react";
import styles from "./Table.module.scss";
import { getScreenSize } from "@utils/getScreenSize";

interface Props {
    link: string;
    date: string;
    transactionType: "Received token" | "Received TON" | "Send TON" | "Swap tokens" | "Received NFT";
    wallet: string;
    amount: string;
    from?: string;
}

const TableRow: FC<Props> = ({ transactionType, from, date, link, amount, wallet }) => {
    const { isMobile } = getScreenSize();
    return (
        <>
            {!isMobile ? (
                <tr className={styles.row}>
                    <td>{date}</td>
                    <td className={styles.transaction}>
                        {["Received token", "Received TON"].includes(transactionType) && (
                            <img height={12} width={12} alt="" src="/images/whale/recieve.svg" />
                        )}
                        {["Received NFT"].includes(transactionType) && (
                            <img height={12} width={12} alt="" src="/images/whale/nft.svg" />
                        )}
                        {["Send TON"].includes(transactionType) && (
                            <img height={12} width={12} alt="" src="/images/whale/send.svg" />
                        )}
                        {["Swap tokens"].includes(transactionType) && (
                            <img height={12} width={12} alt="" src="/images/whale/swap.svg" />
                        )}
                        {transactionType}
                    </td>
                    <td>{wallet}</td>
                    <td>{amount}</td>
                    <td>
                        <a href={link} className={styles.view}>
                            <img width={14} height={14} src="/images/whale/tonviewer.svg" alt="" />
                            <span>Tonviewer</span>
                            <img width={14} height={14} src="/images/scam/arrow.svg" alt="" />
                        </a>
                    </td>
                </tr>
            ) : (
                <div className={styles.mobileRow}>
                    <div className={styles.mobileRowTop}>
                        <div className={styles.mobileRowTransaction}>
                            {["Received token", "Received TON"].includes(transactionType) && (
                                <img height={12} width={12} alt="" src="/images/whale/recieve.svg" />
                            )}
                            {["Received NFT"].includes(transactionType) && (
                                <img height={12} width={12} alt="" src="/images/whale/nft.svg" />
                            )}
                            {["Send TON"].includes(transactionType) && (
                                <img height={12} width={12} alt="" src="/images/whale/send.svg" />
                            )}
                            {["Swap tokens"].includes(transactionType) && (
                                <img height={12} width={12} alt="" src="/images/whale/swap.svg" />
                            )}
                            {transactionType}
                        </div>
                        <a href={link} className={styles.mobileRowDate}>
                            <img width={14} height={14} src="/images/whale/tonviewer.svg" alt="" />
                        </a>
                    </div>
                    <span className={styles.separator} />
                    <div className={styles.mobileRowBottom}>
                        <div className={styles.mobileRowLeft}>{wallet}</div>
                        <div className={styles.mobileRowRight}>
                            <div className={styles.mobileRowAmount}>
                                {from && (
                                    <span className={styles.mobileRowFrom}>
                                        -{from} <img src="/images/swap/right.svg" alt="" />
                                    </span>
                                )}
                                {from && "+"}
                                {amount}
                            </div>
                            <div className={styles.mobileRowDate}>{date}</div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TableRow;
